export {
  default as livingRoom,
  ReactComponent as LivingRoom,
} from '@assets/icons/features-and-amenities/living-room.svg'    
